import request from '@/utils/request';
import { stringify } from 'qs';


// 初始化
export async function getInitialize () {
  return request(`/api/initialize/get`, {})
}

export async function report (params: object) {
  return request(`/log/event/report/h5`, {
    method: 'POST',
    body: params
  })
}

export async function weChatServerGetOpenId(params: object) {
  return request(`/api/weChatServerGetOpenId`, {
    method: 'POST',
    body: params
  })
}

